import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../../services/central-api/dispatch';
import FilterRadioList, { FilterListItem } from '../FilterRadioList';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
}

function ActingBodiesList({ value, setValue }: Props) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getActingBodies() {
        try {
            setIsLoading(true);
            const actingBodies = await dispatchService.getActingBodies();
            setItems(actingBodies.map((actingBody) => ({ value: actingBody.id, label: actingBody.name })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getActingBodies();
    }, []);

    return <FilterRadioList items={items} value={value} setValue={setValue} clearValue={0} isLoading={isLoading} />;
}

export default ActingBodiesList;
